import { useState } from "react";
import { motion } from "framer-motion";
import { Plus } from "lucide-react";
import { FAQ } from "@/data/faq";

const H = { fontFamily: "'Outfit', 'Poppins', sans-serif", fontWeight: 800 };
const B = { fontFamily: "'Poppins', sans-serif" };

/** Häufige Fragen – zugänglicher Akkordeon-Block. Inhalt = Quelle des FAQPage-Schemas (data/faq.js), damit Sichtbares und Markup übereinstimmen. */
export const Faq = ({ items = FAQ, title = "Häufige Fragen", heading = ["Alles, was du", "wissen willst."] }) => {
  const [open, setOpen] = useState(0);
  return (
    <section className="bg-white" data-testid="faq-section" aria-labelledby="faq-h">
      <div className="mx-auto max-w-[840px] px-6 md:px-10 py-8 md:py-24">
        <p style={B} className="text-xs font-bold uppercase tracking-[0.18em] text-[#111]/50">{title}</p>
        <h2 id="faq-h" style={H} className="mt-3 text-[#111] uppercase leading-[1.05] text-3xl md:text-4xl" data-testid="faq-headline">
          {heading[0]} <span className="bg-[#FDD105] px-2">{heading[1]}</span>
        </h2>
        <ul className="mt-6 divide-y divide-[#111]/10 border-y border-[#111]/10">
          {items.map((item, i) => {
            const on = open === i;
            return (
              <li key={item.q} data-testid={`faq-item-${i}`}>
                <h3>
                  <button
                    type="button"
                    onClick={() => setOpen(on ? -1 : i)}
                    aria-expanded={on}
                    aria-controls={`faq-answer-${i}`}
                    style={B}
                    className="flex w-full items-center justify-between gap-4 py-4 text-left text-base md:text-lg font-bold text-[#111] focus:outline-none focus-visible:ring-2 focus-visible:ring-[#FDD105] focus-visible:ring-offset-2"
                    data-testid={`faq-question-${i}`}>
                    <span className="min-w-0">{item.q}</span>
                    <Plus size={20} className={`shrink-0 text-[#111] transition-transform duration-300 ${on ? "rotate-45" : ""}`} aria-hidden="true" />
                  </button>
                </h3>
                <motion.div
                  id={`faq-answer-${i}`}
                  initial={false}
                  animate={{ height: on ? "auto" : 0, opacity: on ? 1 : 0 }}
                  transition={{ duration: 0.3, ease: [0.22, 1, 0.36, 1] }}
                  className="overflow-hidden"
                  data-testid={`faq-answer-${i}`}>
                  <p style={B} className="pb-4 pr-8 text-sm md:text-base text-[#4A4A4A] leading-relaxed">{item.a}</p>
                </motion.div>
              </li>
            );
          })}
        </ul>
      </div>
    </section>
  );
};
